import React, { useState } from 'react';

import { useTemplate } from '../../../../features/template/TemplateProvider';
import useApi from '../../../../hook/useApi';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import { TextareaField } from '../../../../utils/InputField';

function ModalPaymentInfo({ closeModal, handleReload }) {
    const [isError, setIsError] = useState('');
    const { setMessage, modalData } = useTemplate();
    const [loading, setLoading] = useState(false);
    const { put } = useApi();
    const [formData, setFormData] = useState({
        PaymentItemId: modalData?.item?.id || 0,
        PaymentInfo: modalData?.item?.text || '',
        ActionType: modalData?.isEdit ? 'update' : 'add'
    });

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleSaveClick = (e) => {
        e?.preventDefault();
        setLoading(true);
        put('api/setting/invoice-config/payment-info-add', formData)
            .then(({ error, message, referenceName }) => {
                if (error) {
                    setIsError(referenceName);
                    throw new Error(message);
                }
                closeModal();
                handleReload();
                setMessage({
                    type: 'success',
                    text: message || 'Payment information added successfully'
                });
            })
            .catch((err) => {
                setLoading(false);
                setMessage({ type: 'error', text: err?.message || 'Something went wrong' });
            });
    };
    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleSaveClick}>
            <div className="flex flex-col gap-y-3 mb-5">
                <TextareaField
                    label="Payment Information"
                    name="PaymentInfo"
                    placeholder="Type payment information..."
                    formData={formData}
                    onChange={handleChange}
                    className="h-44"
                    required
                />
            </div>

            <div className="flex justify-end">
                <div className="flex items-center gap-x-3">
                    <ButtonCancel title="Cancel" onClick={closeModal} />
                    <ButtonPrimary
                        title={modalData?.isEdit ? 'Update' : 'Add'}
                        btnType="submit"
                        loading={loading}
                    />
                </div>
            </div>
        </form>
    );
}

export default ModalPaymentInfo;
